/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { domainsListDomains } from "../funcs/domainsListDomains.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListCustomDomainsResult } from "../models/components/listcustomdomainsresult.js";
import {
  ListDomainsRequest,
  ListDomainsSecurity,
} from "../models/operations/listdomains.js";
import { unwrapAsync } from "../types/fp.js";
export type ListDomainsQueryData = ListCustomDomainsResult;

export function prefetchListDomains(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListDomainsRequest | undefined,
  security?: ListDomainsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildListDomainsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildListDomainsQuery(
  client$: GramCore,
  request?: ListDomainsRequest | undefined,
  security?: ListDomainsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<ListDomainsQueryData>;
} {
  return {
    queryKey: queryKeyListDomains({ gramSession: request?.gramSession }),
    queryFn: async function listDomainsQueryFn(
      ctx,
    ): Promise<ListDomainsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(domainsListDomains(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyListDomains(
  parameters: { gramSession?: string | undefined },
): QueryKey {
  return ["@gram/client", "domains", "listDomains", parameters];
}
